import {Component, Input, OnInit} from "@angular/core";
import {ConfirmComponent} from "../../../dialogs/confirm/confirm.component";
import {MatDialog, MatDialogRef} from "@angular/material";
import {NotificationService} from "../../../services/notification.service";
import {Project} from "../../../services/model/projects.model";
import {ProjectService} from "../../../services/project.service";
import {environment} from "../../../../environments/environment";
import {ActivatedRoute} from "@angular/router";
import {OutsourcingDialogComponent} from "../../../dialogs/outsourcing/outsourcing-dialog.component";
import {FreelancersService} from "../../../services/freelancers.service";
import {Freelancer} from "../../../services/model/freelancer.model";
import {TimeService} from "../../../services/time.service";
import {FormatService} from "../../../services/format.service";

@Component({
    selector: 'app-outsourcing',
    templateUrl: './outsourcing.component.html',
})
export class OutsourcingComponent implements OnInit{
    items: any;
    freelancers: any;
    list_freelancers: any;
    id: string;
    total: number = 0;
    env = environment;
    dialogRef: MatDialogRef<ConfirmComponent>;
    editRef: MatDialogRef<OutsourcingDialogComponent>;
    @Input('project') project: Project;

    constructor(
        private projectServ: ProjectService,
        private freelanersServ: FreelancersService,
        private activeR: ActivatedRoute,
        public dialog: MatDialog,
        private notifServ: NotificationService,
        public timeServ: TimeService,
        public format: FormatService
    ){
        this.id = this.activeR.snapshot.params['id'];
        this.list_freelancers = {};
    }

    ngOnInit(){

        this.items = this.projectServ.getProjectOutsourcing(this.id).map(actions => {
            return actions.map(a => {
                const data = a.payload.doc.data() as Project;
                const key = a.payload.doc.id;
                return { key, ...data };
            });
        });

        this.getTotal();

        this.freelanersServ.getFreelancers('created_at', 'desc').map(actions => {
            return actions.map(a => {
                const data = a.payload.doc.data() as Freelancer;
                const key = a.payload.doc.id;
                return { key, ...data };
            });
        }).subscribe(
            r => {
                for(let item of r){
                    this.list_freelancers[item.key] = item;
                }
            }
        );
    }

    getTotal(){
        this.items.subscribe(
            r => {
                this.total = 0;
                for(let key in r){
                    this.total += +r[key].cost;
                }
            }
        );
    }

    editItem(status: boolean, item?: any){
        this.editRef = this.dialog.open(OutsourcingDialogComponent, {width: this.env.dialogs.width});
        this.editRef.componentInstance.item = status ? item : {};
        this.editRef.componentInstance.id = this.id;
        this.editRef.componentInstance.started = status ? this.timeServ.getDatePicketFormat(item.started_at) : '';
        this.editRef.componentInstance.finished = status ? this.timeServ.getDatePicketFormat(item.finished_at) : '';
        this.editRef.componentInstance.is_new = !status;

        this.editRef.afterClosed().subscribe(result => {
            // TODO make sure the model does not change the old values
            if(result) {
                this.getTotal()
            } else {
            }
        });
    }

    deleteService(key: string){
        this.projectServ.deleteService(this.id, key).then(
            r => {
                this.notifServ.sendSuccess( 'Service has been deleted');
            }
        )
    }


    openDelete(key: string){
        this.dialogRef = this.dialog.open(ConfirmComponent, {});
        this.dialogRef.componentInstance.confirmMessage = 'Are you sure you want to delete this Service?';

        this.dialogRef.afterClosed().subscribe(result => {
            if(result) {
                this.deleteService(key);
            } else {
            }
        });
    }
}


// WEBPACK FOOTER //
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/projects/shared/outsourcing/outsourcing.component.ts